import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { useAtomValue, useSetAtom } from 'jotai';
import React from 'react';
import { Keyboard, ScrollView } from 'react-native';
import styled from 'styled-components/native';
import DownIcon from '@/assets/icon/ic_angle_bracket_down.svg';
import FilterIcon from '@/assets/icon/ic_filter.svg';
import { SccTouchableOpacity } from '@/components/SccTouchableOpacity';
import { color } from '@/constant/color.ts';
import { font } from '@/constant/font.ts';
import { useExperimentVariant } from '@/hooks/useExperiment';
import { SortOption, filterAtom, filterModalStateAtom, } from '@/screens/SearchScreen/atoms';
export default function SearchFilterPreview() {
    const { sortOption, scoreUnder, hasSlope, isRegistered, hasReview } = useAtomValue(filterAtom);
    const setFilterModalState = useSetAtom(filterModalStateAtom);
    const isScoreUnderActive = scoreUnder !== null;
    const isHasSlopeActive = hasSlope !== null;
    const isIsCompletedActive = isRegistered !== null;
    const isHasReviewActive = hasReview !== null;
    const isHasReviewEnabled = useExperimentVariant('HAS_REVIEW_FILTER') !== 'CONTROL';
    const onFilterPress = (option) => {
        Keyboard.dismiss();
        setFilterModalState(option);
    };
    return (_jsx(ScrollView, { showsHorizontalScrollIndicator: false, horizontal: true, style: { width: '100%', flexGrow: 0 }, children: _jsxs(Container, { children: [_jsxs(Chip, { onPress: () => onFilterPress('All'), isActive: false, children: [_jsx(FilterIcon, { width: 16, height: 16, color: color.gray100 }), _jsx(ChipNumberText, { children: "\uD544\uD130" })] }), _jsxs(Chip, { isActive: false, onPress: () => onFilterPress('sortOption'), children: [_jsx(ChipText, { isActive: false, children: (() => {
                                switch (sortOption) {
                                    case SortOption.ACCURACY:
                                        return '정확도순';
                                    case SortOption.DISTANCE:
                                        return '가까운순';
                                    case SortOption.LOW_SCORE:
                                        return '접근레벨낮은순';
                                }
                            })() }), _jsx(DownIcon, { width: 20, height: 20, color: color.black })] }), _jsx(Chip, { isActive: isIsCompletedActive, onPress: () => onFilterPress('isRegistered'), children: _jsx(ChipText, { isActive: isIsCompletedActive, children: (() => {
                            switch (isRegistered) {
                                case false:
                                    return '정복 안 된 곳';
                                case true:
                                    return '정복된 곳';
                                case null:
                                    return '정복 여부';
                            }
                        })() }) }), _jsx(Chip, { isActive: isScoreUnderActive, onPress: () => onFilterPress('scoreUnder'), children: _jsx(ChipText, { isActive: isScoreUnderActive, children: scoreUnder === null ? '접근레벨' : `접근레벨 ${scoreUnder}이하` }) }), _jsx(Chip, { isActive: isHasSlopeActive, onPress: () => onFilterPress('hasSlope'), children: _jsx(ChipText, { isActive: isHasSlopeActive, children: (() => {
                            switch (hasSlope) {
                                case false:
                                    return '경사로 없음';
                                case true:
                                    return '경사로 있음';
                                case null:
                                    return '경사로 유무';
                            }
                        })() }) }), isHasReviewEnabled && (_jsx(Chip, { isActive: isHasReviewActive, onPress: () => onFilterPress('hasReview'), children: _jsx(ChipText, { isActive: isHasReviewActive, children: hasReview === true ? '리뷰 있는 곳' : '리뷰 유무' }) }))] }) }));
}
function Chip({ children, isActive, onPress, }) {
    return (_jsx(ChipContainer, { elementName: "search_filter_chip", disableLogging: true, activeOpacity: 0.7, onPress: onPress, isActive: isActive, children: children }));
}
const Container = styled.View `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding-right: 30px;
  padding-top: 3px;
  padding-bottom: 8px;
  padding-left: 20px;
  gap: 5px;
`;
const ChipContainer = styled(SccTouchableOpacity) `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${({ isActive }) => (isActive ? color.gray90 : color.white)};
  padding-top: 7px;
  padding-bottom: 7px;
  padding-right: 13px;
  padding-left: 13px;
  border-radius: 56px;
  gap: 4px;
  border-width: 1px;
  border-color: ${color.gray20};
`;
const ChipText = styled.Text `
  font-size: 14px;
  font-family: ${() => font.pretendardMedium};
  color: ${({ isActive }) => (isActive ? color.white : color.gray100)};
`;
const ChipNumberText = styled.Text `
  font-size: 13px;
  text-align: center;
  line-height: 20px;
  font-family: ${() => font.pretendardMedium};
  color: ${color.gray100};
`;
